import React from "react";

import { countryStateColors } from './mapStyle';

const dataMapLegend = [
  [
    'Latest report online',
    countryStateColors.updated
  ],
  [
    `Latest report (not consistent with the online template)`,
    countryStateColors.updatedOffline
  ],
  [
    'Past reports online (reports were submitted online in the past)',
    countryStateColors.old
  ],
  [
    `Past reports (not consistent with the online template)`,
    countryStateColors.oldOffline
  ],
  [
    'No report',
    countryStateColors.noReport
  ]
];

class DataMapLegend extends React.PureComponent {
  renderLegendItems() {
    return dataMapLegend.map(function (item, index) {
      return (
        <li key={index} className="home-map__legend-item">
          <span
            className="tag-table-tag"
            style={{ backgroundColor: item[1] }}
          >
          </span>&ensp;
          { item[0] }
        </li>
      )
    });
  }

  render() {
    return (
      <ul className="home-map__legend">
        { this.renderLegendItems() }
      </ul>
    );
  }
}

export default DataMapLegend;



// WEBPACK FOOTER //
// ./src/components/Home/DataMap/DataMapLegend.js